import React from "react";
import { Box, Dialog } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./HelpPopup.module.css";
import apiKey from "../../Assets/upin.png";

const ApiKeyPopup = (props: any) => {
  const { isOpen, onClose } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      sx={{
        zIndex: "99999",
        minWidth: "400px",
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: "736px",
          maxHeight: "580px",
          // minHeight: "559px",
          padding: "24px",
          borderRadius: "12px",
          boxShadow:
            "0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08)",
          left: "5%",
          top: "8%",
          background: "#FFFFFF",
          overflow: "hidden",
        },
      }}
    >
      <div>
        <div className={styles.closeModalButton}>
          <CloseIcon sx={{ color: "#555555" }} onClick={handleClose} />
        </div>
        <div className={styles.modalHead}>
          Not sure where to find the UPIN Key?
        </div>
        <div className={styles.modalSubHead}>Follow these steps:</div>
        <ul className={styles.stepsToFollow}>
          <li>Login to your Voxbay Admin account.</li>
          <li>Click on Developer icon on left drawer tab.</li>
          <li>Select Click to Call option.</li>
          <li>Copy PIN and paste it here.</li>
        </ul>

        {/* <Box sx={{ width: "100%" }}>
          <img src={apiKey} alt="apiKey" />
        </Box> */}
        <Box
          sx={{ width: "100%", display: "flex", justifyContent: "flex-start" }}
        >
          <img
            src={apiKey}
            alt="apiKey"
            style={{
              width: "100%",
              maxWidth: "100%",
              maxHeight: "200px",
              objectFit: "contain",
            }}
          />
        </Box>
      </div>
    </Dialog>
  );
};
export default ApiKeyPopup;
